export const reduceObject = <T extends unknown, U extends unknown>(
    obj: Record<string, T>,
    callbackfn: (
        previousValue: Record<string, U>,
        currentValue: [string, T],
        currentIndex: number,
        array: Array<[string, T]>
    ) => Record<string, U>
) => Object.entries(obj).reduce<Record<string, U>>(callbackfn, Object.create(null));
